/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetRecentMeshRunsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  creditFacilitySlugsToHide?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  startDate?: Types.Maybe<Types.Scalars['JSDate']>;
  endDate?: Types.Maybe<Types.Scalars['JSDate']>;
}>;


export type GetRecentMeshRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { meshRuns: Types.QueryGQLType['getRecentMeshRuns'] }
);

export type GetLatestMeshRunQueryVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
}>;


export type GetLatestMeshRunQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'getLatestMeshRun'>
);

export type GetAllRecentMeshRunsQueryVariablesGQLType = Types.Exact<{
  startDate?: Types.Maybe<Types.Scalars['JSDate']>;
  endDate?: Types.Maybe<Types.Scalars['JSDate']>;
  limit?: Types.Maybe<Types.Scalars['Int']>;
}>;


export type GetAllRecentMeshRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { allMeshRuns: Types.QueryGQLType['getAllRecentMeshRuns'] }
);

export type GetBorrowerPipelineRunsQueryVariablesGQLType = Types.Exact<{
  borrowerOrganizationId: Types.Scalars['UUID'];
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetBorrowerPipelineRunsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRuns: Array<(
    { __typename?: 'PipelineRun' }
    & Pick<Types.PipelineRunGQLType, 'reportingDate' | 'fileVersion'>
  )> }
);

export type GetPipelineRunsWithArtifactIdsQueryVariablesGQLType = Types.Exact<{
  borrowerOrganizationId: Types.Scalars['UUID'];
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
}>;


export type GetPipelineRunsWithArtifactIdsQueryGQLType = (
  { __typename?: 'Query' }
  & { getPipelineRunsWithArtifactIds: Array<(
    { __typename?: 'PipelineRunWithArtifactIds' }
    & Pick<Types.PipelineRunWithArtifactIdsGQLType, 'reportingDate' | 'fileVersion' | 'uploadedArtifactIds'>
  )> }
);

export type GetMaybeCompleteMeshRunRecordQueryVariablesGQLType = Types.Exact<{
  meshRunId?: Types.Maybe<Types.Scalars['String']>;
  meshRunParams?: Types.Maybe<Types.MeshRunParamsGQLType>;
}>;


export type GetMaybeCompleteMeshRunRecordQueryGQLType = (
  { __typename?: 'Query' }
  & { maybeCompleteMeshRunRecord: Types.QueryGQLType['getCompleteMeshRunRecordIfAvailable'] }
);

export type GetMeshDocumentQueryVariablesGQLType = Types.Exact<{
  meshDocumentId: Types.Scalars['String'];
}>;


export type GetMeshDocumentQueryGQLType = (
  { __typename?: 'Query' }
  & { meshDocument: Types.QueryGQLType['getMeshDocument'] }
);

export type GetLatestMeshDocumentsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  creditFacilitySlugsToHide?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type GetLatestMeshDocumentsQueryGQLType = (
  { __typename?: 'Query' }
  & { latestMeshDocuments: Types.QueryGQLType['getLatestMeshDocuments'] }
);

export type GetLatestMeshDocumentMetadataQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  creditFacilitySlugsToHide?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type GetLatestMeshDocumentMetadataQueryGQLType = (
  { __typename?: 'Query' }
  & { latestMeshDocumentMetadata: Types.QueryGQLType['getLatestMeshDocumentMetadata'] }
);

export type GetDataPipelineDownloadSignedUrlQueryVariablesGQLType = Types.Exact<{
  serializedParams: Types.Scalars['String'];
}>;


export type GetDataPipelineDownloadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { downloadUrls: Array<(
    { __typename?: 'UrlAndFilename' }
    & Pick<Types.UrlAndFilenameGQLType, 'url' | 'filename'>
  )> }
);

export type GetDataPipelineUploadSignedUrlQueryVariablesGQLType = Types.Exact<{
  serializedParams: Types.Scalars['String'];
}>;


export type GetDataPipelineUploadSignedUrlQueryGQLType = (
  { __typename?: 'Query' }
  & { getSignedUploadUrl: (
    { __typename?: 'PresignedPost' }
    & Pick<Types.PresignedPostGQLType, 'url' | 's3RequestFields' | 'queryResponseFields'>
  ) }
);

export type ReUploadLoanTapeMutationVariablesGQLType = Types.Exact<{
  implementationId: Types.Scalars['UUID'];
  artifactId: Types.Scalars['UUID'];
  reportingDate: Types.Scalars['FullDateStr'];
  fileVersion: Types.Scalars['Int'];
  currentArtifactInstanceId: Types.Scalars['UUID'];
}>;


export type ReUploadLoanTapeMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reUploadLoanTape: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);


export const GetRecentMeshRunsDocumentGQLType = gql`
    query GetRecentMeshRuns($organizationId: UUID!, $creditFacilitySlugsToHide: [String!], $startDate: JSDate, $endDate: JSDate) {
  meshRuns: getRecentMeshRuns(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
    startDate: $startDate
    endDate: $endDate
  )
}
    `;

/**
 * __useGetRecentMeshRunsQuery__
 *
 * To run a query within a React component, call `useGetRecentMeshRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentMeshRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentMeshRunsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetRecentMeshRunsQuery(baseOptions: Apollo.QueryHookOptions<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>(GetRecentMeshRunsDocumentGQLType, options);
      }
export function useGetRecentMeshRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>(GetRecentMeshRunsDocumentGQLType, options);
        }
export type GetRecentMeshRunsQueryHookResult = ReturnType<typeof useGetRecentMeshRunsQuery>;
export type GetRecentMeshRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetRecentMeshRunsLazyQueryGQLType>;
export type GetRecentMeshRunsQueryResultGQLType = Apollo.QueryResult<GetRecentMeshRunsQueryGQLType, GetRecentMeshRunsQueryVariablesGQLType>;
export const GetLatestMeshRunDocumentGQLType = gql`
    query GetLatestMeshRun($implementationId: UUID!) {
  getLatestMeshRun(implementationId: $implementationId)
}
    `;

/**
 * __useGetLatestMeshRunQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshRunQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshRunQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshRunQuery({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *   },
 * });
 */
export function useGetLatestMeshRunQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>(GetLatestMeshRunDocumentGQLType, options);
      }
export function useGetLatestMeshRunLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>(GetLatestMeshRunDocumentGQLType, options);
        }
export type GetLatestMeshRunQueryHookResult = ReturnType<typeof useGetLatestMeshRunQuery>;
export type GetLatestMeshRunLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshRunLazyQueryGQLType>;
export type GetLatestMeshRunQueryResultGQLType = Apollo.QueryResult<GetLatestMeshRunQueryGQLType, GetLatestMeshRunQueryVariablesGQLType>;
export const GetAllRecentMeshRunsDocumentGQLType = gql`
    query GetAllRecentMeshRuns($startDate: JSDate, $endDate: JSDate, $limit: Int) {
  allMeshRuns: getAllRecentMeshRuns(
    startDate: $startDate
    endDate: $endDate
    limit: $limit
  )
}
    `;

/**
 * __useGetAllRecentMeshRunsQuery__
 *
 * To run a query within a React component, call `useGetAllRecentMeshRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllRecentMeshRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllRecentMeshRunsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetAllRecentMeshRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>(GetAllRecentMeshRunsDocumentGQLType, options);
      }
export function useGetAllRecentMeshRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>(GetAllRecentMeshRunsDocumentGQLType, options);
        }
export type GetAllRecentMeshRunsQueryHookResult = ReturnType<typeof useGetAllRecentMeshRunsQuery>;
export type GetAllRecentMeshRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetAllRecentMeshRunsLazyQueryGQLType>;
export type GetAllRecentMeshRunsQueryResultGQLType = Apollo.QueryResult<GetAllRecentMeshRunsQueryGQLType, GetAllRecentMeshRunsQueryVariablesGQLType>;
export const GetBorrowerPipelineRunsDocumentGQLType = gql`
    query GetBorrowerPipelineRuns($borrowerOrganizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRuns(
    organizationId: $borrowerOrganizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
  }
}
    `;

/**
 * __useGetBorrowerPipelineRunsQuery__
 *
 * To run a query within a React component, call `useGetBorrowerPipelineRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBorrowerPipelineRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBorrowerPipelineRunsQuery({
 *   variables: {
 *      borrowerOrganizationId: // value for 'borrowerOrganizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetBorrowerPipelineRunsQuery(baseOptions: Apollo.QueryHookOptions<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>(GetBorrowerPipelineRunsDocumentGQLType, options);
      }
export function useGetBorrowerPipelineRunsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>(GetBorrowerPipelineRunsDocumentGQLType, options);
        }
export type GetBorrowerPipelineRunsQueryHookResult = ReturnType<typeof useGetBorrowerPipelineRunsQuery>;
export type GetBorrowerPipelineRunsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetBorrowerPipelineRunsLazyQueryGQLType>;
export type GetBorrowerPipelineRunsQueryResultGQLType = Apollo.QueryResult<GetBorrowerPipelineRunsQueryGQLType, GetBorrowerPipelineRunsQueryVariablesGQLType>;
export const GetPipelineRunsWithArtifactIdsDocumentGQLType = gql`
    query GetPipelineRunsWithArtifactIds($borrowerOrganizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr) {
  getPipelineRunsWithArtifactIds(
    organizationId: $borrowerOrganizationId
    startDate: $startDate
    endDate: $endDate
  ) {
    reportingDate
    fileVersion
    uploadedArtifactIds
  }
}
    `;

/**
 * __useGetPipelineRunsWithArtifactIdsQuery__
 *
 * To run a query within a React component, call `useGetPipelineRunsWithArtifactIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPipelineRunsWithArtifactIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPipelineRunsWithArtifactIdsQuery({
 *   variables: {
 *      borrowerOrganizationId: // value for 'borrowerOrganizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetPipelineRunsWithArtifactIdsQuery(baseOptions: Apollo.QueryHookOptions<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>(GetPipelineRunsWithArtifactIdsDocumentGQLType, options);
      }
export function useGetPipelineRunsWithArtifactIdsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>(GetPipelineRunsWithArtifactIdsDocumentGQLType, options);
        }
export type GetPipelineRunsWithArtifactIdsQueryHookResult = ReturnType<typeof useGetPipelineRunsWithArtifactIdsQuery>;
export type GetPipelineRunsWithArtifactIdsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPipelineRunsWithArtifactIdsLazyQueryGQLType>;
export type GetPipelineRunsWithArtifactIdsQueryResultGQLType = Apollo.QueryResult<GetPipelineRunsWithArtifactIdsQueryGQLType, GetPipelineRunsWithArtifactIdsQueryVariablesGQLType>;
export const GetMaybeCompleteMeshRunRecordDocumentGQLType = gql`
    query GetMaybeCompleteMeshRunRecord($meshRunId: String, $meshRunParams: MeshRunParams) {
  maybeCompleteMeshRunRecord: getCompleteMeshRunRecordIfAvailable(
    meshRunId: $meshRunId
    meshRunParams: $meshRunParams
  )
}
    `;

/**
 * __useGetMaybeCompleteMeshRunRecordQuery__
 *
 * To run a query within a React component, call `useGetMaybeCompleteMeshRunRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMaybeCompleteMeshRunRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMaybeCompleteMeshRunRecordQuery({
 *   variables: {
 *      meshRunId: // value for 'meshRunId'
 *      meshRunParams: // value for 'meshRunParams'
 *   },
 * });
 */
export function useGetMaybeCompleteMeshRunRecordQuery(baseOptions?: Apollo.QueryHookOptions<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>(GetMaybeCompleteMeshRunRecordDocumentGQLType, options);
      }
export function useGetMaybeCompleteMeshRunRecordLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>(GetMaybeCompleteMeshRunRecordDocumentGQLType, options);
        }
export type GetMaybeCompleteMeshRunRecordQueryHookResult = ReturnType<typeof useGetMaybeCompleteMeshRunRecordQuery>;
export type GetMaybeCompleteMeshRunRecordLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMaybeCompleteMeshRunRecordLazyQueryGQLType>;
export type GetMaybeCompleteMeshRunRecordQueryResultGQLType = Apollo.QueryResult<GetMaybeCompleteMeshRunRecordQueryGQLType, GetMaybeCompleteMeshRunRecordQueryVariablesGQLType>;
export const GetMeshDocumentDocumentGQLType = gql`
    query GetMeshDocument($meshDocumentId: String!) {
  meshDocument: getMeshDocument(meshDocumentId: $meshDocumentId)
}
    `;

/**
 * __useGetMeshDocumentQuery__
 *
 * To run a query within a React component, call `useGetMeshDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeshDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeshDocumentQuery({
 *   variables: {
 *      meshDocumentId: // value for 'meshDocumentId'
 *   },
 * });
 */
export function useGetMeshDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>(GetMeshDocumentDocumentGQLType, options);
      }
export function useGetMeshDocumentLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>(GetMeshDocumentDocumentGQLType, options);
        }
export type GetMeshDocumentQueryHookResult = ReturnType<typeof useGetMeshDocumentQuery>;
export type GetMeshDocumentLazyQueryGQLTypeHookResult = ReturnType<typeof useGetMeshDocumentLazyQueryGQLType>;
export type GetMeshDocumentQueryResultGQLType = Apollo.QueryResult<GetMeshDocumentQueryGQLType, GetMeshDocumentQueryVariablesGQLType>;
export const GetLatestMeshDocumentsDocumentGQLType = gql`
    query GetLatestMeshDocuments($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]) {
  latestMeshDocuments: getLatestMeshDocuments(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  )
}
    `;

/**
 * __useGetLatestMeshDocumentsQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshDocumentsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetLatestMeshDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>(GetLatestMeshDocumentsDocumentGQLType, options);
      }
export function useGetLatestMeshDocumentsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>(GetLatestMeshDocumentsDocumentGQLType, options);
        }
export type GetLatestMeshDocumentsQueryHookResult = ReturnType<typeof useGetLatestMeshDocumentsQuery>;
export type GetLatestMeshDocumentsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshDocumentsLazyQueryGQLType>;
export type GetLatestMeshDocumentsQueryResultGQLType = Apollo.QueryResult<GetLatestMeshDocumentsQueryGQLType, GetLatestMeshDocumentsQueryVariablesGQLType>;
export const GetLatestMeshDocumentMetadataDocumentGQLType = gql`
    query GetLatestMeshDocumentMetadata($organizationId: UUID!, $creditFacilitySlugsToHide: [String!]) {
  latestMeshDocumentMetadata: getLatestMeshDocumentMetadata(
    organizationId: $organizationId
    creditFacilitySlugsToHide: $creditFacilitySlugsToHide
  )
}
    `;

/**
 * __useGetLatestMeshDocumentMetadataQuery__
 *
 * To run a query within a React component, call `useGetLatestMeshDocumentMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestMeshDocumentMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestMeshDocumentMetadataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditFacilitySlugsToHide: // value for 'creditFacilitySlugsToHide'
 *   },
 * });
 */
export function useGetLatestMeshDocumentMetadataQuery(baseOptions: Apollo.QueryHookOptions<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>(GetLatestMeshDocumentMetadataDocumentGQLType, options);
      }
export function useGetLatestMeshDocumentMetadataLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>(GetLatestMeshDocumentMetadataDocumentGQLType, options);
        }
export type GetLatestMeshDocumentMetadataQueryHookResult = ReturnType<typeof useGetLatestMeshDocumentMetadataQuery>;
export type GetLatestMeshDocumentMetadataLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestMeshDocumentMetadataLazyQueryGQLType>;
export type GetLatestMeshDocumentMetadataQueryResultGQLType = Apollo.QueryResult<GetLatestMeshDocumentMetadataQueryGQLType, GetLatestMeshDocumentMetadataQueryVariablesGQLType>;
export const GetDataPipelineDownloadSignedUrlDocumentGQLType = gql`
    query getDataPipelineDownloadSignedUrl($serializedParams: String!) {
  downloadUrls: getSignedDownloadUrls(
    feature: "dataPipelineInstanceRecord"
    serializedParams: $serializedParams
  ) {
    url
    filename
  }
}
    `;

/**
 * __useGetDataPipelineDownloadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDataPipelineDownloadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPipelineDownloadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPipelineDownloadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDataPipelineDownloadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>(GetDataPipelineDownloadSignedUrlDocumentGQLType, options);
      }
export function useGetDataPipelineDownloadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>(GetDataPipelineDownloadSignedUrlDocumentGQLType, options);
        }
export type GetDataPipelineDownloadSignedUrlQueryHookResult = ReturnType<typeof useGetDataPipelineDownloadSignedUrlQuery>;
export type GetDataPipelineDownloadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDataPipelineDownloadSignedUrlLazyQueryGQLType>;
export type GetDataPipelineDownloadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDataPipelineDownloadSignedUrlQueryGQLType, GetDataPipelineDownloadSignedUrlQueryVariablesGQLType>;
export const GetDataPipelineUploadSignedUrlDocumentGQLType = gql`
    query getDataPipelineUploadSignedUrl($serializedParams: String!) {
  getSignedUploadUrl(
    feature: "getDataPipelineUploadDestination"
    serializedParams: $serializedParams
  ) {
    url
    s3RequestFields
    queryResponseFields
  }
}
    `;

/**
 * __useGetDataPipelineUploadSignedUrlQuery__
 *
 * To run a query within a React component, call `useGetDataPipelineUploadSignedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDataPipelineUploadSignedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDataPipelineUploadSignedUrlQuery({
 *   variables: {
 *      serializedParams: // value for 'serializedParams'
 *   },
 * });
 */
export function useGetDataPipelineUploadSignedUrlQuery(baseOptions: Apollo.QueryHookOptions<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>(GetDataPipelineUploadSignedUrlDocumentGQLType, options);
      }
export function useGetDataPipelineUploadSignedUrlLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>(GetDataPipelineUploadSignedUrlDocumentGQLType, options);
        }
export type GetDataPipelineUploadSignedUrlQueryHookResult = ReturnType<typeof useGetDataPipelineUploadSignedUrlQuery>;
export type GetDataPipelineUploadSignedUrlLazyQueryGQLTypeHookResult = ReturnType<typeof useGetDataPipelineUploadSignedUrlLazyQueryGQLType>;
export type GetDataPipelineUploadSignedUrlQueryResultGQLType = Apollo.QueryResult<GetDataPipelineUploadSignedUrlQueryGQLType, GetDataPipelineUploadSignedUrlQueryVariablesGQLType>;
export const ReUploadLoanTapeDocumentGQLType = gql`
    mutation ReUploadLoanTape($implementationId: UUID!, $artifactId: UUID!, $reportingDate: FullDateStr!, $fileVersion: Int!, $currentArtifactInstanceId: UUID!) {
  reUploadLoanTape(
    implementationId: $implementationId
    artifactId: $artifactId
    reportingDate: $reportingDate
    fileVersion: $fileVersion
    currentArtifactInstanceId: $currentArtifactInstanceId
  ) {
    response
  }
}
    `;
export type ReUploadLoanTapeMutationFnGQLType = Apollo.MutationFunction<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>;

/**
 * __useReUploadLoanTapeMutation__
 *
 * To run a mutation, you first call `useReUploadLoanTapeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReUploadLoanTapeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reUploadLoanTapeMutation, { data, loading, error }] = useReUploadLoanTapeMutation({
 *   variables: {
 *      implementationId: // value for 'implementationId'
 *      artifactId: // value for 'artifactId'
 *      reportingDate: // value for 'reportingDate'
 *      fileVersion: // value for 'fileVersion'
 *      currentArtifactInstanceId: // value for 'currentArtifactInstanceId'
 *   },
 * });
 */
export function useReUploadLoanTapeMutation(baseOptions?: Apollo.MutationHookOptions<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>(ReUploadLoanTapeDocumentGQLType, options);
      }
export type ReUploadLoanTapeMutationHookResult = ReturnType<typeof useReUploadLoanTapeMutation>;
export type ReUploadLoanTapeMutationResultGQLType = Apollo.MutationResult<ReUploadLoanTapeMutationGQLType>;
export type ReUploadLoanTapeMutationOptionsGQLType = Apollo.BaseMutationOptions<ReUploadLoanTapeMutationGQLType, ReUploadLoanTapeMutationVariablesGQLType>;